// extracted by mini-css-extract-plugin
module.exports = {"DetailCollege":"DetailedCollege_DetailCollege___9RzI","Statistics":"DetailedCollege_Statistics__1Ux4e"};